<div class="order-summary" [class.no-padding]="noPadding">
  <!-- Headline -->
  <div class="header" [class.collapsed]="isCollapsed">
    <div class="headline">{{ headline }}</div>
    @if (callToAction) {
      <a class="href" [class.long]="isCallToActionLong" (click)="onCallToActionClick()">{{ callToAction }}</a>
    }
  </div>

  @if (!order || isLoading) {
    <!-- Dummy order lines shown before order is ready -->
    <div class="updating">
      @for (x of [].constructor(dummyOrderLineCount); track x; let i = $index) {
        <div class="row item" [class.collapsed]="isCollapsed">
          <div class="col-9 item-label">
            <label class="item-title dummy-item" [ngClass]="getDummyItemSizeClass(i)">&nbsp;</label>
          </div>
          <div class="col-3 item-price">
            <div class="dummy-item" [ngClass]="getDummyItemSizeClass(i)">&nbsp;</div>
          </div>
        </div>
      }
    </div>
  } @else {
    <!-- Order lines -->
    @for (line of order.orderLines; track line; let i = $index) {
      <!-- `visually-hidden` is Bootstrap's own helper (already compiled in): off-screen, still read
           aloud. See `visuallyHidden` on LegacyOrderLine for why a line would want that.
           THIS is the component the booking panel, the cancel dialog and manage-booking render —
           the lib of nearly the same name serves the wizard and guest drop-off. Both need it. -->
      <div class="row item" [class.collapsed]="isCollapsed" [class.visually-hidden]="line.visuallyHidden">
        <div class="col-9 item-label" [class.text-success]="line.unitPrice < 0">
          <label class="item-title" [class.disabled]="line.selected === false">
            @if (line.optional && line.unitPrice > 0 && !isReadOnly) {
              <input
                type="checkbox"
                [id]="'orderLine' + i + 'Selected'"
                [name]="'orderLine' + i + 'Selected'"
                [(ngModel)]="line.selected"
                (change)="onOrderLineChange(line)"
              />
            }
            <span>
              {{ line.product.name | translate }}
              @if (line.showQuantity) {
                <span>
                  @if (line.showUnitPrice && line.product.unitSingular) {
                    <span
                      >({{ line.unitPrice | price: order.currency : 2 }}/{{
                        line.product.unitSingular | translate | lowercase
                      }})</span
                    >
                  }
                  @if (!line.showQuantityAsUpTo) {
                    <span
                      >x {{ line.quantity }}
                      {{
                        (line.quantity === 1 ? line.product.unitSingular : line.product.unitPlural)
                          | translate
                          | lowercase
                      }}</span
                    >
                  }
                  @if (line.showQuantityAsUpTo) {
                    <span
                      >,
                      {{
                        line.quantity === 1
                          ? ('UP_TO_ONE_BAG' | translate)
                          : ('UP_TO_X_BAGS_COUNT' | translate: { count: line.quantity })
                      }}
                    </span>
                  }
                </span>
              }
            </span>
          </label>
          @if (line.product.info && isInfoEnabled) {
            <lh-shared-ui-tooltip
              callToAction="i"
              [header]="line.product.info.header | translate"
              [body]="line.product.info.body | translate"
            ></lh-shared-ui-tooltip>
          }
        </div>
        <div
          class="col-3 item-price"
          [class.text-success]="line.unitPrice < 0"
          [class.disabled]="line.optional && !line.selected"
        >
          <span [class.free-item]="isIncludedForFree(line)">{{ getPriceText(line) | translate }}</span>
        </div>
      </div>
    }
  }

  <!-- Divider -->
  <div class="row item" [class.collapsed]="isCollapsed">
    <div class="col-12">
      <hr />
    </div>
  </div>

  <!-- Total -->
  <div class="row item">
    <div class="col-12 total">
      @if (totalLabel) {
        <span>{{ totalLabel }}</span>
      }
      @if (!totalLabel) {
        <span class="dummy-item updating">&nbsp;</span>
      }

      <div class="total-amount">
        @if (orderTotal) {
          <span>{{ orderTotal }}</span>
        }
        @if (!orderTotal) {
          <span class="dummy-item updating">&nbsp;</span>
        }
      </div>
    </div>

    @if (totalNote | async) {
      <div class="col-12 total-note">{{ totalNote | async }}</div>
    }
  </div>
</div>
